export const countries = [
  { key: 'Sverige', value: 'Sverige' },
  { key: 'Norge', value: 'Norge' },
  { key: 'Danmark', value: 'Danmark' },
  { key: 'Finland', value: 'Finland' },
  { key: 'Tyskland', value: 'Tyskland' },
  { key: 'Storbritannien', value: 'Storbritannien' },
  { key: 'Frankrike', value: 'Frankrike' },
  { key: 'Nederländerna', value: 'Nederländerna' },
  { key: 'Belgien', value: 'Belgien' },
  { key: 'Schweiz', value: 'Schweiz' },
  { key: 'Österrike', value: 'Österrike' },
  { key: 'Spanien', value: 'Spanien' },
  { key: 'Italien', value: 'Italien' },
  { key: 'Portugal', value: 'Portugal' },
  { key: 'Grekland', value: 'Grekland' },
  { key: 'Polen', value: 'Polen' },
  { key: 'Tjeckien', value: 'Tjeckien' },
  { key: 'Ungern', value: 'Ungern' },
  { key: 'Rumänien', value: 'Rumänien' },
  { key: 'Irland', value: 'Irland' }
]
